import { Box, IconButton } from "@mui/material";
import FileCopy from "@mui/icons-material/FileCopy";

type CloneButtonProps = {
  onClick: () => void;
};

const CloneButton = ({ onClick }: CloneButtonProps) => {
  const handleClick = (e: any) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Box textAlign="center">
      <IconButton size="small" onClick={handleClick}>
        <FileCopy />
      </IconButton>
    </Box>
  );
};

export default CloneButton;
